module.exports = __webpack_public_path__ + "img/gc_country_flag_hk.e6494660.svg";